<template>

    <m-edit1/>

    <m-reset-cellphone-password-1 v-bind='{...{"image":null},...{}}' :style='""' class="" ></m-reset-cellphone-password-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mResetCellphonePassword1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/ResetCellPhonePassword/ResetCellphonePassword1';

export default {
    name: 'HomeView',
    components: {mEdit1, mResetCellphonePassword1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
